"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.allowedRandomColors = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var tokens_1 = __importDefault(require("@servicetitan/tokens"));
var Icon_1 = require("../Icon");
exports.allowedRandomColors = [
    /* 400 */
    tokens_1.default.colorBlueGrey400,
    tokens_1.default.colorOrange400,
    tokens_1.default.colorCyan400,
    tokens_1.default.colorPurple400,
    tokens_1.default.colorMagenta400,
    /* 600  */
    tokens_1.default.colorBlueGrey600,
    tokens_1.default.colorOrange600,
    tokens_1.default.colorCyan600,
    tokens_1.default.colorPurple600,
    tokens_1.default.colorMagenta600,
];
var Avatar = function (_a) {
    var autoColor = _a.autoColor, className = _a.className, _b = _a.color, color = _b === void 0 ? tokens_1.default.colorBlueGrey100 : _b, image = _a.image, name = _a.name, rounded = _a.rounded, _c = _a.size, size = _c === void 0 ? 'm' : _c, icon = _a.icon, props = __rest(_a, ["autoColor", "className", "color", "image", "name", "rounded", "size", "icon"]);
    var getRandomColor = function () {
        var colorLength = exports.allowedRandomColors.length;
        var nameLength = name ? name.length : icon.length;
        var colorIndex = (nameLength - 1) % colorLength;
        return exports.allowedRandomColors[colorIndex];
    };
    var getInitials = function () {
        if (!name)
            return;
        var nameSplit = name.split(' ');
        var first = nameSplit[0].substr(0, 1);
        var last = nameSplit.length > 1 ? nameSplit.pop().substr(0, 1) : '';
        return "" + first + last;
    };
    var getContent = function () {
        if (name) {
            return getInitials();
        }
        if (icon) {
            return react_1.default.createElement(Icon_1.Icon, { name: icon });
        }
    };
    var customColor = color;
    if (!image && autoColor)
        customColor = getRandomColor();
    var AvatarClasses = classnames_1.default('Avatar', className, "Avatar--" + size, {
        'Avatar--circle': !rounded,
        'Avatar--rounded': rounded,
        'Avatar--text-alignment': !!name,
        'Avatar--lightText': utilities_1.isDark(customColor),
        'Avatar--icon': !name && !!icon,
    });
    var style = image
        ? {
            backgroundImage: "url(" + image + ")",
        }
        : {
            backgroundColor: customColor,
        };
    return (react_1.default.createElement("div", __assign({ "aria-label": name, className: AvatarClasses, style: style, title: name }, props), getContent()));
};
exports.Avatar = Avatar;
//# sourceMappingURL=Avatar.js.map